import { FormattedMessage } from "react-intl";

import { ChevronRight } from "@mui/icons-material";

const MenuItemText = (props) => {
  const { item, parentItem, isActive } = props;
  // MenuConfig now supplies an MUI icon component rather than a class name.
  const Icon = item.icon;

  return (
    <>
      {Icon && <Icon className="kt-menu__link-icon" fontSize="inherit" />}

      {item.iconUrl && (
        <div className={`svg-kt-menu__link-icon ${isActive ? "text-primary" : ""}`}>
          <img alt="icon" src={item.iconUrl} />
        </div>
      )}

      {parentItem && parentItem.bullet === "dot" && (
        <i className="kt-menu__link-bullet kt-menu__link-bullet--dot">
          <span />
        </i>
      )}

      {parentItem && parentItem.bullet === "line" && (
        <i className="kt-menu__link-bullet kt-menu__link-bullet--line">
          <span />
        </i>
      )}

      <span className="kt-menu__link-text" style={{ whiteSpace: "nowrap" }}>
        {!item.translate ? (
          item.title
        ) : (
          <FormattedMessage id={item.translate} defaultMessage={item.title} />
        )}
      </span>

      {item.badge && (
        <span className="kt-menu__link-badge">
          <span className={`kt-badge ${item.badge.type}`}>{item.badge.value}</span>
        </span>
      )}

      {item.submenu && <ChevronRight className="kt-menu__ver-arrow" fontSize="inherit" />}
    </>
  );
};

export default MenuItemText;
